import {z} from 'zod';

export const scanLicensePlateResponseSchema = z.object({
  licensePlate: z.string().nullable(),
});

export type ScanLicensePlateResponse = z.infer<typeof scanLicensePlateResponseSchema>;
